import { makeSx } from '../../../../theme/_utils'
import { defaultPalette } from '../../../../theme/idsTheme'

export default makeSx({
    text: {
        width: '75%',
        color: defaultPalette.error.main,
        fontSize: '12px',
        textDecoration: 'none',
        marginTop: '-10px',
    },
})
